module.exports = __webpack_public_path__ + "static/media/snow-ocean.6e81201d.jpg";